import PropTypes from 'prop-types'
import Tooltip from '../../common/tooltip'
import { downloadFile, formatEmptyValue } from '../../../utils/common'
import { Edit, Trash, Download } from '@styled-icons/boxicons-solid'

const DevicesRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-1 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-3/12 items-center table_text">
          <Tooltip message={props?.name}>
            <div>{formatEmptyValue(props?.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.category}>
            <div>{formatEmptyValue(props?.category)}</div>
          </Tooltip>
        </div>
        <div className="w-4/12 pl-6 items-center table_text">
          <Tooltip message={props?.description}>
            <div>{props?.description}</div>
          </Tooltip>
        </div>
        <div className="w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.alias?.value}>
            <div>{props?.alias?.value}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center justify-end">
          {props?.svg && (
            <span
              onClick={() => {
                downloadFile(props.svg, `${props.name}.svg`)
              }}
              className="cursor-pointer px-1"
            >
              <Download size="2rem" color="#0189E9" />
            </span>
          )}

          <span
            onClick={() => {
              props.onShowDetails()
            }}
            className="cursor-pointer px-1"
          >
            <Edit size="2rem" color="#0189E9" />
          </span>
          <span
            onClick={() => {
              props.onDelete()
            }}
            className="cursor-pointer px-1"
          >
            <Trash size="2rem" color="#0189E9" />
          </span>
        </div>
      </div>
    </div>
  )
}

DevicesRow.propTypes = {
  onShowDetails: PropTypes.func,
  onDelete: PropTypes.func,
}

export default DevicesRow
